/**
 * XO Club - Composant de Notification de Mise à Jour
 * ===================================================
 * Affiche une bannière quand une nouvelle version est disponible.
 */

import { useBuildVersion } from '../hooks/useBuildVersion';
import { Button } from './ui/button';
import { RefreshCw, X } from 'lucide-react';
import { useState } from 'react';

export function UpdateNotification() {
  const { updateAvailable, forceRefresh, isChecking } = useBuildVersion();
  const [dismissed, setDismissed] = useState(false);

  if (!updateAvailable || dismissed) {
    return null;
  }

  return (
    <div 
      className="fixed bottom-20 left-4 right-4 z-50 animate-in slide-in-from-bottom-4 duration-300"
      data-testid="update-notification"
    >
      <div className="bg-gradient-to-r from-[#00d4ff] to-[#00ff88] rounded-xl p-4 shadow-2xl">
        <div className="flex items-center justify-between gap-3">
          <div className="flex-1">
            <p className="text-black font-bold text-sm">
              🚀 Nouvelle version disponible !
            </p>
            <p className="text-black/70 text-xs mt-1">
              Rafraîchissez pour profiter des dernières améliorations.
            </p>
          </div>
          
          <div className="flex items-center gap-2">
            <Button
              onClick={forceRefresh}
              disabled={isChecking}
              size="sm"
              className="bg-black text-white hover:bg-black/80 font-bold"
              data-testid="refresh-app-button"
            >
              {isChecking ? (
                <RefreshCw className="w-4 h-4 animate-spin" />
              ) : (
                <>
                  <RefreshCw className="w-4 h-4 mr-1" />
                  Rafraîchir
                </>
              )}
            </Button>
            
            <button
              onClick={() => setDismissed(true)}
              className="p-1 hover:bg-black/10 rounded-full transition-colors"
              data-testid="dismiss-update-button"
            >
              <X className="w-5 h-5 text-black/60" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateNotification;
